'use strict'

class Home {
    
  constructor() {
    
  }

  init () {
    var slider = tns({
      container: '#categorySlider',
      controls: false,
      nav: true,
      slideBy: 1,
      navPosition: 'bottom',
      speed: 750,
      mouseDrag: true,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          "items": 3
        },
        992: {
          preventActionWhenRunning: true,
        }
      }
    });
  }
}

export default Home;